"use strict";const e=require("./_commonjsHelpers-6763f629.js"),r=require("./_baseIsEqual-944e53e6.js");var l=r._baseIsEqual;function q(a,u){return l(a,u)}var s=q;const t=e.getDefaultExportFromCjs(s);exports.isEqual=t;exports.isEqual_1=s;
